module.exports = __webpack_public_path__ + "img/ru.ad2a3f46.svg";